import { defineStore } from 'pinia'

import type { TutorSlotLogStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useTutorSlotLogStore = defineStore('tutor-slot-log', {
  state: (): TutorSlotLogStore => ({
    loading: false,
    filterTutorId: null,
    filterDate: null,
    filterSlotTime: null,
    selectedTutorOption: null,
    logsPaginatedData: null,
    hasSearched: false,
  }),
  actions,
  getters,
})
